import * as React from "react"
import { useTheme } from "../../ThemeContext";
const IconCategoryCoverage = (props) => {
    const { theme } = useTheme();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={63}
            height={62}
            fill="none"
            {...props}
        >
            <rect width={62} height={62} x={0.666} fill={theme === 'dark' ? "#37395B" : "#E7FEF6"} rx={31} />
            <path
                stroke={theme === 'dark' ? "#9aa1a7" : "#6C6C82"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M17.333 16.334h11v11h-11v-11ZM35.666 16.334h11v11h-11v-11ZM17.333 34.667h11v11h-11v-11ZM35.666 40.167a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0Z"
            />
        </svg>
    )
}
export default IconCategoryCoverage
